(function () {
    "use strict";

    angular
        .module("app")
        .directive('layoutConfig', layoutConfig);

        function layoutConfig($compile, $filter, $timeout, $rootScope, $location, UserPreferenceService, cfpLoadingBar, toaster) {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, ele, attrs) {
                    scope.getFieldsId = parseInt(attrs.layoutConfig);
                    scope.form = scope.$eval(attrs.form);
                    scope.fieldConfigurationForm = false;

                    scope.gridsterOpts = {
                        columns: 1, // the width of the grid, in columns
                        pushing: true, // whether to push other items out of the way on move or resize
                        floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                        swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                        width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                        colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                        rowHeight: '35', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                        margins: [0, 0], // the pixel distance between each widget
                        outerMargin: false, // whether margins apply to outer edges of the grid
                        sparse: false, // "true" can increase performance of dragging and resizing for big grid (e.g. 20x50)
                        isMobile: false, // stacks the grid items if true
                        mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
                        mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                        minColumns: 1, // the minimum columns the grid must have
                        minRows: 2, // the minimum height of the grid, in rows
                        maxRows: 200,
                        defaultSizeX: 1, // the default width of a gridster item, if not specifed
                        defaultSizeY: 1, // the default height of a gridster item, if not specified
                        minSizeX: 1, // minimum column width of an item
                        maxSizeX: 1, // maximum column width of an item
                        minSizeY: 1, // minumum row height of an item
                        maxSizeY: 1, // maximum row height of an item,
                        defaultCol: 0,
                        resizable: {
                            enabled: false
                        },
                        draggable: {
                            enabled: true, // whether dragging items is supported
                            handle: '.gridster-handle', // optional selector for drag handle
                            start: function (event, $element, widget) {
                                if (scope.form.$pristine) {
                                    scope.itWasPristine = true;
                                }
                            },
                            stop: function (event, $element, widget) {

                                //setFormDirty();
                                rowStageRow(widget, 200, true);
                            }
                        }
                    };

                    function resetUrl() {
                        //setParentFormPristine();
                        $location.url($location.path());
                    }

                    function setFormDirty() {
                        scope.fieldConfigurationForm = true;
                    }

                    function setFormPristine() {
                        scope.fieldConfigurationForm = false;
                    }

                    function setParentFormPristine() {
                        $timeout(function () {
                            scope.form.$setPristine();
                        }, 0);
                    }

                    function rowStageRow(item, time, drag, apply) {
                        if (item) {
                            if (item.rowStage === '' || item.rowStage === null || isNaN(item.rowStage)) {
                                item.rowStage = item.row;
                            }

                            if (isNaN(item.rowStage) || parseInt(item.rowStage) == item.row)
                                return;

                            if (item.rowStage > item.row) {
                                item.rowStage = parseInt(item.rowStage) + 1;
                            }

                            if (drag) {
                                item.rowStage = item.row;
                            } else {
                                item.row = item.rowStage;
                            }
                        }
                        $timeout(function () {
                            var counter = 0;
                            angular.forEach(scope.fields, function (a, b) {
                                a.rowStage = a.row;
                            });

                            var nonHiddenfields = $filter('filter')(scope.fields, { Hidden: false });
                            counter = nonHiddenfields.length;

                            angular.forEach($filter('orderBy')($filter('filter')(scope.fields, { Hidden: true }), 'row'), function (a, b) {
                                a.row = counter;
                                a.rowStage = counter;
                                counter++;
                            });

                            if (scope.itWasPristine) {
                                setParentFormPristine();
                                scope.itWasPristine = false;
                            }
                            if (!apply)
                                setFormDirty();

                        }, time);
                    }

                    scope.rowStage = function (e, item, blur) {
                        if (e.keyCode === 13) {
                            rowStageRow(item, 200);
                        }
                        if (blur) {
                            rowStageRow(item, 200);
                        }
                    }

                    scope.rowStageForm = function () {
                        if (scope.form.$pristine) {
                            scope.itWasPristine = true;
                        }
                    }

                    scope.mouseenter = function (item, event) {
                        var id = parseInt(item.FieldId);
                        var h = angular.element(document.getElementById(id));
                        h.addClass('hover');
                    }

                    scope.mouseleave = function (item, event) {
                        var id = parseInt(item.FieldId);
                        var h = angular.element(document.getElementById(id));
                        h.removeClass('hover');
                    }
                    scope.sort = function (sortDefault) {
                        if (sortDefault) {
                            if (scope.form.$pristine) {
                                scope.itWasPristine = true;
                            }

                            scope.fields = angular.copy(scope.defaultFieldData);

                            rowStageRow(false, 0);

                            scope.alpha = '-';
                            $timeout(function () {
                                if (scope.itWasPristine) {
                                    setParentFormPristine();
                                }
                                resetUrl();
                            }, 0);
                        } else {
                            scope.alpha = scope.alpha == '' ? '-' : '';
                            var sorted = $filter('orderBy')(angular.copy(scope.fields), ['Hidden', scope.alpha + 'Label']);
                            angular.forEach(sorted, function (k, v) {
                                k.row = v;
                                k.rowStage = v;
                            });
                            scope.fields = sorted;
                            setFormDirty();
                        }
                        /*
                        $timeout(function () {
                            scope.filterSearch(scope.filter);
                        }, 0);
                        */
                    }

                    scope.handleHiddenRow = function (a, i) {
                        scope.fieldConfigurationForm = true;
                        if (scope.form.$pristine) {
                            scope.itWasPristine = true;
                        }
                        a.Hidden = !a.Hidden;

                        if (scope.itWasPristine) {
                            setParentFormPristine();
                            scope.itWasPristine = false;
                        }

                        if (a.Hidden) {
                            var l = $filter('filter')(scope.fields, { Hidden: false }).length;
                            a.rowStage = l;
                        } else {
                            var l = $filter('filter')(scope.fields, { Hidden: false }).length - 1;
                            a.rowStage = l;
                        }

                        rowStageRow(false, 200);
                    }

                    scope.showHide = function (a) {
                        scope.fieldConfigurationForm = true;
                        if (scope.form.$pristine) {
                            scope.itWasPristine = true;
                        }

                        var tempFields = angular.copy(scope.fields);
                        angular.forEach(tempFields, function (k) {
                            k.Hidden = a;
                        });
                        scope.fields = tempFields;
                        //keep the filter going
                        scope.filterSearch(scope.filter);

                        if (scope.itWasPristine) {
                            setParentFormPristine();
                            scope.itWasPristine = false;
                        }

                        rowStageRow(false, 100);
                    }

                    scope.layoutToggle = function () {
                        ele.toggleClass('ng-show');
                        var lp = angular.element(document.querySelectorAll('#layoutPanel'));
                        lp.toggleClass('ng-show');
                        var pane = angular.element(document.querySelectorAll('.tab-content .tab-pane:first-child'));
                        var mar = pane[0].style.marginLeft;

                        if (!mar || mar == '0px') {
                            pane[0].style.marginLeft = 350 + 'px';
                        }
                        else {
                            pane[0].style.marginLeft = 0;
                        }
                    }

                    scope.deleteBlankLine = function (item) {
                        var index = scope.fields.map(function (e) { return e.FieldId }).indexOf(item.FieldId);
                        item.Hidden = true;
                        if (item.New) {
                            scope.fields.splice(index, 1);
                        }
                        rowStageRow(false, 200);
                    }

                    scope.hiddenFieldsFilter = function (e) {
                        //console.log(e);
                        var test = e.Hidden == true && e.FieldId < 999;
                        return test;
                    }

                    scope.addBlankLine = function (item,newItem,apply) {
                        var l = $filter('filter')(scope.fields, function (e) { return e.Hidden==true && e.FieldId > 999 });
                        /*var hiddenCount = $filter('filter')(scope.fields, function (e) { return e.Hidden === false && e.FieldId > 999 });
                        console.log(l, hiddenCount);
                        if (hiddenCount.length === 10 && !l.length)
                            return;
                            */
                        if (l.length) {
                            //get lowest id and return to a non deleted state
                            var lowestId = $filter('orderBy')(l, 'FieldId')[0];
                            var row = $filter('filter')(scope.fields, { Hidden: false }).length;
                            lowestId.row = row;
                            lowestId.rowStage = row;
                            lowestId.Hidden = false;
                        } else {
                            var fieldId = 0;
                            var l = 0;
                            if (item) {
                                l = item.row;
                                fieldId = item.FieldId;
                            } else {
                                l = $filter('filter')(scope.fields, { Hidden: false }).length;
                                var count = $filter('orderBy')($filter('filter')(scope.fields, { Label: 'Blank Line' }), 'FieldId', true)[0];
                                if (count) {
                                    fieldId = count.FieldId + 1;
                                } else {
                                    fieldId = 1000;
                                }
                            }

                            scope.fields.push({
                                Id: item ? item.Id : false,
                                FieldId: fieldId,
                                ModuleId: parseInt(scope.getFieldsId),
                                UserId: parseInt($rootScope.userId),
                                row: l,
                                rowStage: l,
                                col: 0,
                                html: "<p></p>",
                                class: "col-md-12 field-blank-line",
                                Label: "Blank Line",
                                Hidden: false,
                                New: newItem
                            });
                            if (!apply)
                                rowStageRow(false, 200);
                        }
                    }

                    var layoutToggle = '<div><button type="button" class="btn btn-primary" ng-click="layoutToggle()" ><i class="fa fa-cog"></i>&nbsp;Fields</button></div><div class="vr"></div>';
                    var a = angular.element(document.querySelectorAll('.sticky-box'));
                    var element = angular.element(layoutToggle);
                    a.prepend(element);
                    $compile(element)(scope);

                    scope.filterSearch = function (s) {
                        var elements = angular.element(document.querySelector('.the_grid'))[0].children;
                        var firstResult = -1;
                        var results = 0;
                        angular.forEach(elements, function (k) {
                            var ele = k.querySelector('.item-label');
                            ele.innerHTML = ele.innerText;
                            var re = new RegExp(s, "i");
                            var regTest = ele.innerText.match(re);
                            if (regTest !== null) {
                                results++;
                                if (firstResult == -1) {
                                    var offset = (k.offsetTop > 20 ? 20 : 0);
                                    firstResult = k.offsetTop;
                                }
                                var newHtml = ele.innerText.replace(regTest[0], '<h>' + regTest[0] + '</h>');
                                ele.innerHTML = newHtml;
                            }
                        });
                        scope.filterResults = results + ' found';
                        //document.querySelector('#layoutConfig').scrollTop = firstResult;
                    }

                    scope.getProfile = function (userProfile) {
                        scope.applyProfile(userProfile);
                        setFormPristine();

                        setParentFormPristine();
                        resetUrl();
                    }

                    scope.discardProfile = function () {
                        scope.discard = true;
                    }

                    scope.applyProfile = function (config, apply) {
                        //handle blank lines
                        var allBlankLines = $filter('filter')(config, function (e) { return e.FieldId > 999 });
                        //add all new blank lines
                        angular.forEach(allBlankLines, function (k, v) {
                            var configIndex = scope.fields.map(function (e) { return e.FieldId }).indexOf(k.FieldId);
                            if (configIndex === -1) {
                                scope.addBlankLine(k, false, true);
                            }
                        });

                        //apply users configuration here
                        var tempProfile = angular.copy(scope.fields);

                        if (config[0].UserId == $rootScope.userId) {
                            scope.urlId = false;
                            resetUrl();
                        }
                        var spliceCount = 0;
                        var removeBlanks = [];
                        angular.forEach(tempProfile, function (k, v) {
                            var configIndex = config.map(function (e) { return e.FieldId }).indexOf(k.FieldId);
                            if (configIndex > -1) {
                                k.row = config[configIndex].row;
                                k.rowStage = k.row;
                                k.Hidden = config[configIndex].Hidden;
                                k.Id = config[configIndex].Id;
                            } else {
                                if (k.FieldId > 999) {//remove blank lines
                                    removeBlanks.push(k.row);
                                } else {
                                    //if a new field, add to end
                                    k.row = config.length;
                                }
                            }
                        });

                        //properly remove blank lines. lol
                        angular.forEach($filter('orderBy')(removeBlanks, '', 'desc'), function (k) {
                            tempProfile.splice(k, 1);
                        });

                        scope.fields = tempProfile;

                        rowStageRow(false, 50, false, apply);
                        
                        //$timeout(function () {
                        setFormPristine(); //set pristine on the first
                        setParentFormPristine();
                        //},0);
                    }

                    //must be rootscope so the modal in views will work
                    $rootScope.shareProfile = function (form, save) {
                        if (form) {
                            $('#profileChanged').modal('show');
                            return;
                        }
                        if (save) {
                            scope.SaveFields(true);
                            return;
                        }
                        var url = $location.absUrl().indexOf('profile') > -1 ? $location.absUrl().replace(/(profile=)[^\&]+/, '$1' + $rootScope.userId) : $location.absUrl() + '?profile=' + $rootScope.userId;

                        // create temp element
                        var copy = document.createElement("span");
                        copy.id = 'removeLater';
                        copy.appendChild(document.createTextNode(url));
                        angular.element(document.body.appendChild(copy));

                        // select the text
                        var selectText = document.createRange();
                        selectText.selectNode(copy);
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(selectText);

                        // copy & cleanup
                        document.execCommand('copy');
                        window.getSelection().removeAllRanges();
                        $('#removeLater').remove();

                        toaster.pop({
                            type: 'info',
                            title: 'Copied URL to Clipboard',
                            body: '',
                            timeout: 1000
                        });
                    }

                    scope.urlId = $location.search().profile;
                    var userId = scope.urlId || $rootScope.userId;

                    UserPreferenceService.getFieldConfiguration(userId, scope.getFieldsId).then(function (response) {
                        scope.defaultFieldData = angular.copy(scope.fields); //use for sorting and default
                        
                        scope.userProfile = $filter('filter')(response, { UserId: $rootScope.userId }); //current user profile
                        var externalProfile = $filter('filter')(response, { UserId: scope.urlId }); //other user profile they are viewing

                        if (externalProfile.length > 0) {
                            scope.applyProfile(externalProfile,true);
                        }

                        if (scope.userProfile.length > 0 && externalProfile.length == 0) {
                            scope.applyProfile(scope.userProfile,true);
                        }
                        cfpLoadingBar.complete();
                    });

                    function profileView(event) {
                        if (scope.fieldConfigurationForm) {
                            if (!confirm("Your profile is not yet saved, click Cancel and please save before continuing.")) {
                                event.preventDefault();
                                cfpLoadingBar.complete();
                            }
                        }
                    }

                    window.onbeforeunload = function () {
                        if ($location.search().profile) {
                            return "You are currently viewing another users profile, do you wish to save this profile as your own?";
                        } else {
                            if (scope.fieldConfigurationForm) {
                                return "Your profile is not yet saved, click Cancel and please save before continuing.";
                            }
                        }
                    }

                    scope.$on('$stateChangeStart', function (event, newState, newStateParams) {
                        profileView(event);
                    });

                    scope.$on('$locationChangeStart', function (event, next, current) {
                        profileView(event);
                    });

                    scope.SaveFields = function (share) {
                        scope.fieldUpdate = [];
                        angular.forEach(scope.fields, function (k, v) {

                            var item = {
                                UserId: parseInt($rootScope.userId),
                                ModuleId: k.ModuleId,
                                FieldId: k.FieldId,
                                Row: k.row,
                                Hidden: k.Hidden
                            }

                            scope.fieldUpdate.push(item);
                        });
                        
                        UserPreferenceService.updateFieldConfiguration(scope.fieldUpdate, scope.getFieldsId).then(function (response) {
                            if (response.IsSuccessful) {
                                scope.userProfile = scope.fields; //assign user profile
                                toaster.pop({
                                    type: 'success',
                                    title: 'Success!',
                                    body: 'Field Profile Saved',
                                    timeout: 5000
                                });
                                
                                var removeLines = $filter('filter')(scope.fieldUpdate, function (e) { return e.FieldId > 999 && e.Hidden === true });
                                var fieldCopy = angular.copy(scope.fields);
                                angular.forEach(removeLines, function (k, v) {
                                    var index = scope.fields.map(function (e) { return e.FieldId }).indexOf(k.FieldId);
                                    fieldCopy.splice(index - v, 1);
                                    
                                });

                                angular.forEach(fieldCopy, function (k, v) {
                                    if (k.New === true) {
                                        k.New = false;
                                    }
                                });
                                scope.fields = fieldCopy;

                                if (share) {
                                    $rootScope.shareProfile();
                                }
                                setFormPristine();
                                //setParentFormPristine();
                                if (scope.urlId) {
                                    resetUrl();
                                    scope.urlId = false;
                                }
                            } else {
                                toaster.pop({
                                    type: 'error',
                                    title: 'Error',
                                    body: 'Field Profile failed to save. ' + response.Message,
                                    timeout: 5000
                                });
                            }
                        });
                    }
                },
                templateUrl: templateUrl('app/directives/hiddenFields/fieldConfiguration.tpl.html')
            }
        }
})();
